import { useState, useEffect  } from 'react';
import {useNavigate} from "react-router-dom"
import { Box, Heading, Text, VStack, Image} from '@chakra-ui/react';

export default function PaySuccess() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      if (countdown > 1) {
        setCountdown(prevCountdown => prevCountdown - 1);
      } else {
        clearInterval(interval);
        navigate('/trialdash/authentication');
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [countdown]);

  return (
    <Box textAlign="center" py={10} px={6}>
      <VStack gap={5}>
        <Image
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png?w=740&t=st=1687867003~exp=1687867603~hmac=873567be5d0f0e8b3894469ee1a5f7e0d332fb10afe580353dc23ddc1b7553bf"
          alt="Check Mark"
          boxSize="200px"
        />
        <Heading as="h2" size="xl" mt={6} mb={2}>
          Payment Successful!!
        </Heading>
        <Text color="gray.500">
          Thank you for your payment. Your order has been successfully processed.
          We will send you a confirmation email with the details shortly.
        </Text>
        <Text>
          Redirecting to your dashboard in {countdown} seconds...
        </Text>
      </VStack>
    </Box>
  );
}
